export const OKR_GRADE_TYPES = {
  DEFAULT: 'default',
  DEFAULT_NEXT: 'default-next'
}

export const BINARY_VALUES = {
  INCOMPLETE: 0,
  COMPLETE: 1
}

export const BINARY_OPTIONS = [
  {
    label: 'objective.incomplete',
    value: BINARY_VALUES.INCOMPLETE,
    icon: 'result-type-incomplete'
  },
  { label: 'objective.complete', value: BINARY_VALUES.COMPLETE, icon: 'result-type-complete' }
]
